<template>
  <div>
    <SelectList
      v-if="!!users.length"
      v-model="selectedUserId"
      clearable
      dense
      label="Select User"
      option-label="name"
      :options="users"
      @update:model-value="loadStreams"
    />
    <QCheckbox
      v-if="userGroups.length"
      v-model="selectAll"
      class="q-pl-lg"
      label="Select All"
      @update:model-value="toggleSelectAll"
    />

    <div class="row">
      <div
        v-for="group in userGroups"
        :key="group.id"
        class="col-md-5 col-sm-5"
      >
        <QList>
          <QItemLabel
            :key="group.id"
            header
          >
            {{ group.label }}
          </QItemLabel>
          <QItem
            v-for="stream in group.streams"
            :key="stream.id"
          >
            <QItemSection
              side
              top
            >
              <QCheckbox
                v-model="stream.selected"
                @update:model-value="updateStreamSelection(stream)"
              />
            </QItemSection>
            <QItemSection>
              <QItemLabel>
                {{ stream.label }}
              </QItemLabel>
            </QItemSection>
          </QItem>
        </QList>
      </div>
    </div>
  </div>
</template>

<script>
import { groupBy } from "lodash-es";

import Stream from "shared/resources/Stream";

import SelectList from "src/components/common/SelectList.vue";

export default {
  name: "StreamBulkSelect",
  components: {
    SelectList,
  },
  props: {
    organisationId: {
      type: [Number, String],
      required: true,
    },
    streamType: {
      type: [Number, String],
      required: true,
    },
    modelValue: {
      type: Array,
      default: () => [],
    },
    users: {
      type: Array,
      required: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      selectedUserId: "",
      selectAll: false,
      streams: [],
    };
  },
  computed: {
    selectedStreams() {
      return this.modelValue;
    },
    groupedStreams() {
      const streamsWithSelection = this.streams.map((stream) => ({
        ...stream,
        selected: Boolean(
          this.selectedStreams.find((streamId) => streamId === stream.id)
        ),
      }));

      const streamGroups = groupBy(streamsWithSelection, "groupId");

      return Object.keys(streamGroups).map((key) => ({
        id: key,
        label: streamGroups[key][0].group?.label,
        userId: streamGroups[key][0].userId,
        streams: streamGroups[key],
      }));
    },
    userGroups() {
      return this.groupedStreams.filter(
        (group) => group.userId === this.selectedUserId
      );
    },
  },
  mounted() {
    this.selectedUserId = this.users[0].id;
    this.loadStreams();
  },
  methods: {
    async loadStreams() {
      try {
        this.$q.loading.show();

        const response = await Stream.where({
          organisationId: this.organisationId,
          type: this.streamType,
          userId: this.selectedUserId,
          archived: false,
        })
          .includes("group")
          .per(1000)
          .all();

        this.streams = response.data;
      } catch (error) {
        this.$error("Unable to load streams", error);
      } finally {
        this.$q.loading.hide();
      }
    },
    updateStreamSelection(stream) {
      if (stream.selected) {
        this.selectedStreams.push(stream.id);
      } else {
        const index = this.selectedStreams.indexOf(stream.id);
        this.selectedStreams.splice(index, 1);
      }

      this.$emit("update:modelValue", this.selectedStreams);
    },
    toggleSelectAll() {
      const selected = this.selectAll
        ? this.streams.map((stream) => stream.id)
        : [];

      this.$emit("update:modelValue", selected);
    },
  },
};
</script>
